// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__JUWaS","navbar":"styles_navbar__zQEyc"};